import { render, staticRenderFns } from "./Table_custom_valores.vue?vue&type=template&id=08082628&"
import script from "./Table_custom_valores.vue?vue&type=script&lang=js&"
export * from "./Table_custom_valores.vue?vue&type=script&lang=js&"
import style0 from "./Table_custom_valores.vue?vue&type=style&index=0&id=08082628&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports